import { crmClient } from './crm-client';
import type { CreateInteractionRequest } from '@/types';

export class InteractionService {
  private static instance: InteractionService;

  private constructor() {}

  static getInstance(): InteractionService {
    if (!InteractionService.instance) {
      InteractionService.instance = new InteractionService();
    }
    return InteractionService.instance;
  }

  async createDiagnosticCompletedInteraction(
    oportunidadeId: number,
    score: number,
    recommendation: string
  ): Promise<void> {
    const content = `Diagnóstico de Franqueabilidade concluído.

Score: ${score}%
Recomendação: ${recommendation}

O lead respondeu todas as perguntas do diagnóstico. O PDF com a análise completa foi anexado a esta oportunidade.`;

    const request: CreateInteractionRequest = {
      oportunidadeId,
      tipoInteracao: 'COMMENT',
      conteudo: content,
      dataAgenda: null
    };

    console.log('[Interaction] Creating interaction for oportunidade:', oportunidadeId);
    console.log('[Interaction] Content:', content);

    try {
      const result = await crmClient.post('/OportunidadeInteracao', request, true);
      console.log('[Interaction] Created successfully:', result);
    } catch (error) {
      console.error('[Interaction] Error creating interaction:', error);
      throw error;
    }
  }
}

export const interactionService = InteractionService.getInstance();
